/**
 * Generic Fetch Actions
 *
 */
export const REQUEST_STARTED = 'REQUEST_STARTED';
export function requestStarted() {
  return {
    type: REQUEST_STARTED,
    isFetching: true,
  };
}

export const REQUEST_COMPLETED = 'REQUEST_COMPLETED';
export function requestStopped() {
  return {
    type: REQUEST_COMPLETED,
    isFetching: false,
  };
}

export const APP_ERROR = 'APP_ERROR';
export function onAppError(error) {
  return {
    type: APP_ERROR,
    error: error,
  };
}

export const CLEAR_APP_ERROR = 'CLEAR_APP_ERROR';
export function clearAppError() {
  return {
    type: CLEAR_APP_ERROR,
    error: null,
  };
}

export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export function handleSessionExpired() {
  return {
    type: SESSION_EXPIRED,
  };
}

/**
 * Entity Specific Actions
 *
 */
export const SEARCH_CRITERIA_SPECIFIED = 'SEARCH_CRITERIA_SPECIFIED';
export function searchCriteriaSpecified(critera) {
  return {
    type: SEARCH_CRITERIA_SPECIFIED,
    searchCriteria: critera,
  };
}

export const ENTITIES_FETCHED = 'ENTITIES_FETCHED';
export function entitiesFetched(entities) {
  return {
    type: ENTITIES_FETCHED,
    entities: entities,
  };
}

/**
 * Saved searches fetched Actions
 */
export const SAVED_SEARCHES_FETCHED = 'SAVED_SEARCHES_FETCHED';
export function savedSearchesFetched(savedSearches) {
  return {
    type: SAVED_SEARCHES_FETCHED,
    savedSearches: savedSearches,
  };
}

/**
 * Notify user select a search to edit
 */
export const SAVED_SEARCH_EDIT = 'SAVED_SEARCH_EDIT';
export function savedSearchEdit(editId, criteria) {
  return {
    type: SAVED_SEARCH_EDIT,
    editId: editId,
    searchCriteria: criteria,
  };
}
/**
 * Notify user cancel an edit (by delete the saved search which is being editted)
 */
export const SAVED_SEARCH_CANCEL_EDIT = 'SAVED_SEARCH_CANCEL_EDIT';
export function savedSearchCancelEdit() {
  return {
    type: SAVED_SEARCH_CANCEL_EDIT,
  };
}

/**
 * Notify view to edit the saved search
 */
export const SAVED_SEARCH_EDIT_VIEW = 'SAVED_SEARCH_EDIT_VIEW';
export function savedSearchEditView(view = '') {
  return {
    type: SAVED_SEARCH_EDIT_VIEW,
    view: view,
  };
}

/**
 * Notify the edit search is changed.
 */
export const EDIT_SEARCH_CHANGED = 'EDIT_SEARCH_CHANGED';
export function editSearchChanged() {
  return {
    type: EDIT_SEARCH_CHANGED,
  };
}

/**
 * Notify the edit search is reset to original.
 */
export const EDIT_SEARCH_UNCHANGED = 'EDIT_SEARCH_UNCHANGED';
export function editSearchUnchanged() {
  return {
    type: EDIT_SEARCH_UNCHANGED,
  };
}

/**
 * Reset search criteria to default state
 */
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export function clearSearch() {
  return {
    type: CLEAR_SEARCH,
  };
}

/**
 * Favorites fetched Actions
 */
export const FAVORITES_FETCHED = 'FAVORITES_FETCHED';
export function favoritesFetched(favorites) {
  return {
    type: FAVORITES_FETCHED,
    favorites: favorites,
  };
}

/**
 * Detailed Results Actions
 */
export const ENTITY_SELECTED = 'ENTITY_SELECTED';
export function entitySelected(entity, module) {
  return {
    type: ENTITY_SELECTED,
    entity: entity,
    module: module,
  };
}

/**
 * Entity Detail Actions
 */

export const ENTITY_DETAIL_FETCHED = 'ENTITY_DETAIL_FETCHED';
export function entityDetailFetched(entityDetail) {
  return {
    type: ENTITY_DETAIL_FETCHED,
    entityDetail: entityDetail,
  };
}

export const ENTITY_DETAILS_REQUEST_STARTED = 'ENTITY_DETAILS_REQUEST_STARTED';
export function entityDetailsRequestStarted() {
  return {
    type: ENTITY_DETAILS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const ENTITY_DETAILS_REQUEST_ERROR = 'ENTITY_DETAILS_REQUEST_ERROR';
export function entityDetailsRequestError() {
  return {
    type: ENTITY_DETAILS_REQUEST_ERROR,
  };
}

/**
 *  Hazards Actions
 */
export const HAZARDS_FETCHED = 'HAZARDS_FETCHED';
export function hazardsFetched(hazardReport) {
  return {
    type: HAZARDS_FETCHED,
    hazardReport: hazardReport,
  };
}

export const HAZARD_REQUEST_STARTED = 'HAZARD_REQUEST_STARTED';
export function hazardRequestStarted() {
  return {
    type: HAZARD_REQUEST_STARTED,
    isFetching: true,
  };
}

export const HAZARD_REQUEST_ERROR = 'HAZARD_REQUEST_ERROR';
export function hazardRequestError() {
  return {
    type: HAZARD_REQUEST_ERROR,
  };
}

/**
 * DOT Actions
 */
export const DOT_FETCHED = 'DOT_FETCHED';
export function dotFetched(dotReport) {
  return {
    type: DOT_FETCHED,
    dotReport: dotReport,
  };
}

export const DOT_REQUEST_STARTED = 'DOT_REQUEST_STARTED';
export function dotRequestStarted() {
  return {
    type: DOT_REQUEST_STARTED,
    isFetching: true,
  };
}

export const DOT_REQUEST_ERROR = 'DOT_REQUEST_ERROR';
export function dotRequestError() {
  return {
    type: DOT_REQUEST_ERROR,
  };
}
/**
 * WC Actions
 */
export const WC_FETCHED = 'WC_FETCHED';
export function wcFetched(wcReport) {
  return {
    type: WC_FETCHED,
    wcReport: wcReport,
  };
}

export const WC_REQUEST_STARTED = 'WC_REQUEST_STARTED';
export function wcRequestStarted() {
  return {
    type: WC_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WC_REQUEST_ERROR = 'WC_REQUEST_ERROR';
export function wcRequestError() {
  return {
    type: WC_REQUEST_ERROR,
  };
}
/**
 * Welfare Actions
 */
export const WELFARE_SUMMARIES_FETCHED = 'WELFARE_SUMMARIES_FETCHED';
export function welfareSummariesFetched(welfareSummaries) {
  return {
    type: WELFARE_SUMMARIES_FETCHED,
    welfareSummaries: welfareSummaries,
  };
}
export const WELFARE_SUMMARIES_REQUEST_STARTED = 'WELFARE_SUMMARIES_REQUEST_STARTED';
export function welfareSummariesRequestStarted() {
  return {
    type: WELFARE_SUMMARIES_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_SUMMARIES_REQUEST_ERROR = 'WELFARE_SUMMARIES_REQUEST_ERROR';
export function welfareSummariesRequestError() {
  return {
    type: WELFARE_SUMMARIES_REQUEST_ERROR,
  };
}

export const WELFARE_LOBS_FETCHED = 'WELFARE_LOBS_FETCHED';
export function welfareLinesOfBusinessFetched(welfareLinesOfBusiness) {
  return {
    type: WELFARE_LOBS_FETCHED,
    welfareLinesOfBusiness: welfareLinesOfBusiness,
  };
}
export const WELFARE_LOBS_REQUEST_STARTED = 'WELFARE_LOBS_REQUEST_STARTED';
export function welfareLinesOfBusinessRequestStarted() {
  return {
    type: WELFARE_LOBS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_LOBS_REQUEST_ERROR = 'WELFARE_LOBS_REQUEST_ERROR';
export function welfareLinesOfBusinessRequestError() {
  return {
    type: WELFARE_LOBS_REQUEST_ERROR,
  };
}

export const WELFARE_BROKER_SUMMARIES_FETCHED = 'WELFARE_BROKER_SUMMARIES_FETCHED';
export function welfareBrokerSummariesFetched(welfareBrokerSummaries) {
  return {
    type: WELFARE_BROKER_SUMMARIES_FETCHED,
    welfareBrokerSummaries: welfareBrokerSummaries,
  };
}
export const WELFARE_BROKER_SUMMARIES_REQUEST_STARTED = 'WELFARE_BROKER_SUMMARIES_REQUEST_STARTED';
export function welfareBrokerSummariesRequestStarted() {
  return {
    type: WELFARE_BROKER_SUMMARIES_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_BROKER_SUMMARIES_REQUEST_ERROR = 'WELFARE_BROKER_SUMMARIES_REQUEST_ERROR';
export function welfareBrokerSummariesRequestError() {
  return {
    type: WELFARE_BROKER_SUMMARIES_REQUEST_ERROR,
  };
}

//Welfare Broker Summaries History
export const WELFARE_BROKER_SUMMARIES_HISTORY_FETCHED = 'WELFARE_BROKER_SUMMARIES_HISTORY_FETCHED';
export function welfareBrokerSummariesHistoryFetched(welfareBrokerSummariesHistory) {
  return {
    type: WELFARE_BROKER_SUMMARIES_HISTORY_FETCHED,
    welfareBrokerSummariesHistory: welfareBrokerSummariesHistory,
  };
}
export const WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_STARTED =
  'WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_STARTED';
export function welfareBrokerSummariesHistoryRequestStarted() {
  return {
    type: WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_ERROR =
  'WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_ERROR';
export function welfareBrokerSummariesHistoryRequestError() {
  return {
    type: WELFARE_BROKER_SUMMARIES_HISTORY_REQUEST_ERROR,
  };
}

export const WELFARE_SERVICE_PROVIDER_SUMMARIES_FETCHED =
  'WELFARE_SERVICE_PROVIDER_SUMMARIES_FETCHED';
export function welfareServiceProviderSummariesFetched(welfareServiceProviderSummaries) {
  return {
    type: WELFARE_SERVICE_PROVIDER_SUMMARIES_FETCHED,
    welfareServiceProviderSummaries: welfareServiceProviderSummaries,
  };
}
export const WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_STARTED =
  'WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_STARTED';
export function welfareServiceProviderSummariesRequestStarted() {
  return {
    type: WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_ERROR =
  'WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_ERROR';
export function welfareServiceProviderSummariesRequestError() {
  return {
    type: WELFARE_SERVICE_PROVIDER_SUMMARIES_REQUEST_ERROR,
  };
}

// WELFARE - SERVICE_PROVIDERS

export const WELFARE_SERVICE_PROVIDERS_FETCHED = 'WELFARE_SERVICE_PROVIDERS_FETCHED';
export function welfareServiceProvidersFetched(welfareServiceProviders) {
  return {
    type: WELFARE_SERVICE_PROVIDERS_FETCHED,
    welfareServiceProviders: welfareServiceProviders,
  };
}
export const WELFARE_SERVICE_PROVIDERS_REQUEST_STARTED =
  'WELFARE_SERVICE_PROVIDERS_REQUEST_STARTED';
export function welfareServiceProvidersRequestStarted() {
  return {
    type: WELFARE_SERVICE_PROVIDERS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const WELFARE_SERVICE_PROVIDERS_REQUEST_ERROR = 'WELFARE_SERVICE_PROVIDERS_REQUEST_ERROR';
export function welfareServiceProvidersRequestError() {
  return {
    type: WELFARE_SERVICE_PROVIDERS_REQUEST_ERROR,
  };
}

// RETIREMENT

export const RETIREMENT_SUMMARIES_FETCHED = 'RETIREMENT_SUMMARIES_FETCHED';
export function retirementSummariesFetched(retirementSummaries) {
  return {
    type: RETIREMENT_SUMMARIES_FETCHED,
    retirementSummaries: retirementSummaries,
  };
}
export const RETIREMENT_SUMMARIES_REQUEST_STARTED = 'RETIREMENT_SUMMARIES_REQUEST_STARTED';
export function retirementSummariesRequestStarted() {
  return {
    type: RETIREMENT_SUMMARIES_REQUEST_STARTED,
    isFetching: true,
  };
}

export const RETIREMENT_SUMMARIES_REQUEST_ERROR = 'RETIREMENT_SUMMARIES_REQUEST_ERROR';
export function retirementSummariesRequestError() {
  return {
    type: RETIREMENT_SUMMARIES_REQUEST_ERROR,
  };
}

export const RETIREMENT_PLANS_FETCHED = 'RETIREMENT_PLANS_FETCHED';
export function retirementPlansFetched(retirementPlans) {
  return {
    type: RETIREMENT_PLANS_FETCHED,
    retirementPlans: retirementPlans,
  };
}
export const RETIREMENT_PLANS_REQUEST_STARTED = 'RETIREMENT_PLANS_REQUEST_STARTED';
export function retirementPlansRequestStarted() {
  return {
    type: RETIREMENT_PLANS_REQUEST_STARTED,
    isFetching: true,
  };
}
export const RETIREMENT_PLANS_REQUEST_ERROR = 'RETIREMENT_PLANS_REQUEST_ERROR';
export function retirementPlansRequestError() {
  return {
    type: RETIREMENT_PLANS_REQUEST_ERROR,
  };
}

export const RETIREMENT_PLANS_HISTORY_FETCHED = 'RETIREMENT_PLANS_HISTORY_FETCHED';
export function retirementPlansHistoryFetched(retirementPlansHistory) {
  return {
    type: RETIREMENT_PLANS_HISTORY_FETCHED,
    retirementPlansHistory: retirementPlansHistory,
  };
}
export const RETIREMENT_PLANS_HISTORY_REQUEST_STARTED = 'RETIREMENT_PLANS_HISTORY_REQUEST_STARTED';
export function retirementPlansHistoryRequestStarted() {
  return {
    type: RETIREMENT_PLANS_HISTORY_REQUEST_STARTED,
  };
}
export const RETIREMENT_PLANS_HISTORY_REQUEST_ERROR = 'RETIREMENT_PLANS_HISTORY_REQUEST_ERROR';
export function retirementPlansHistoryRequestError() {
  return {
    type: RETIREMENT_PLANS_HISTORY_REQUEST_ERROR,
  };
}

export const RETIREMENT_PROVIDER_SUMMARIES_FETCHED = 'RETIREMENT_PROVIDER_SUMMARIES_FETCHED';
export function retirementProviderSummariesFetched(retirementProviderSummaries) {
  return {
    type: RETIREMENT_PROVIDER_SUMMARIES_FETCHED,
    retirementProviderSummaries: retirementProviderSummaries,
  };
}
export const RETIREMENT_PROVIDER_SUMMARIES_REQUEST_STARTED =
  'RETIREMENT_PROVIDER_SUMMARIES_REQUEST_STARTED';
export function retirementProviderSummariesRequestStarted() {
  return {
    type: RETIREMENT_PROVIDER_SUMMARIES_REQUEST_STARTED,
    isFetching: true,
  };
}

export const RETIREMENT_PROVIDER_SUMMARIES_REQUEST_ERROR =
  'RETIREMENT_PROVIDER_SUMMARIES_REQUEST_ERROR';
export function retirementProviderSummariesRequestError() {
  return {
    type: RETIREMENT_PROVIDER_SUMMARIES_REQUEST_ERROR,
  };
}

// RETIREMENT_SERVICE_PROVIDERS
export const RETIREMENT_SERVICE_PROVIDERS_FETCHED = 'RETIREMENT_SERVICE_PROVIDERS_FETCHED';
export function retirementServiceProvidersFetched(retirementServiceProviders) {
  return {
    type: RETIREMENT_SERVICE_PROVIDERS_FETCHED,
    retirementServiceProviders: retirementServiceProviders,
  };
}
export const RETIREMENT_SERVICE_PROVIDERS_REQUEST_STARTED =
  'RETIREMENT_SERVICE_PROVIDERS_REQUEST_STARTED';
export function retirementServiceProvidersRequestStarted() {
  return {
    type: RETIREMENT_SERVICE_PROVIDERS_REQUEST_STARTED,
    isFetching: true,
  };
}

export const RETIREMENT_SERVICE_PROVIDERS_REQUEST_ERROR =
  'RETIREMENT_SERVICE_PROVIDERS_REQUEST_ERROR';
export function retirementServiceProvidersRequestError() {
  return {
    type: RETIREMENT_SERVICE_PROVIDERS_REQUEST_ERROR,
  };
}

// OSHA
export const OSHA_REPORT_FETCHED = 'OSHA_REPORT_FETCHED';
export function oshaReportFetched(oshaReport) {
  return {
    type: OSHA_REPORT_FETCHED,
    oshaReport: oshaReport,
  };
}
export const OSHA_REPORT_REQUEST_STARTED = 'OSHA_REPORT_REQUEST_STARTED';
export function oshaReportRequestStarted() {
  return {
    type: OSHA_REPORT_REQUEST_STARTED,
    isFetching: true,
  };
}

export const OSHA_REPORT_REQUEST_ERROR = 'OSHA_REPORT_REQUEST_ERROR';
export function oshaReportRequestError() {
  return {
    type: OSHA_REPORT_REQUEST_ERROR,
  };
}

// WHD
export const WHD_REPORT_FETCHED = 'WHD_REPORT_FETCHED';
export function whdReportFetched(whdReport) {
  return {
    type: WHD_REPORT_FETCHED,
    whdReport: whdReport,
  };
}
export const WHD_REPORT_REQUEST_STARTED = 'WHD_REPORT_REQUEST_STARTED';
export function whdReportRequestStarted() {
  return {
    type: WHD_REPORT_REQUEST_STARTED,
    isFetching: true,
  };
}
export const WHD_REPORT_REQUEST_ERROR = 'WHD_REPORT_REQUEST_ERROR';
export function whdReportRequestError() {
  return {
    type: WHD_REPORT_REQUEST_ERROR,
  };
}

/**
 * user Notes fetched Actions
 */
export const USER_NOTES_FETCHED = 'USER_NOTES_FETCHED';
export function userNotesFetched(userNotes) {
  return {
    type: USER_NOTES_FETCHED,
    userNotes: userNotes,
  };
}
export const USER_NOTES_REQUEST_STARTED = 'USER_NOTES_REQUEST_STARTED';
export function userNotesRequestStarted() {
  return {
    type: USER_NOTES_REQUEST_STARTED,
    isFetching: true,
  };
}
export const USER_NOTES_REQUEST_ERROR = 'USER_NOTES_REQUEST_ERROR';
export function userNotesRequestError() {
  return {
    type: USER_NOTES_REQUEST_ERROR,
  };
}

/**
 * Dup Ams account fetched Actions
 */
export const DUP_AMS_ACCOUNTS_FETCHED = 'DUP_AMS_ACCOUNTS_FETCHED';
export function dupAmsAccountsFetched(dupAmsAccounts) {
  return {
    type: DUP_AMS_ACCOUNTS_FETCHED,
    dupAmsAccounts: dupAmsAccounts,
  };
}
export const DUP_AMS_ACCOUNTS_REQUEST_STARTED = 'DUP_AMS_ACCOUNTS_REQUEST_STARTED';
export function dupAmsAccountsRequestStarted() {
  return {
    type: DUP_AMS_ACCOUNTS_REQUEST_STARTED,
    isFetching: true,
    dupAmsAccounts: null,
  };
}
export const DUP_AMS_ACCOUNTS_REQUEST_ERROR = 'DUP_AMS_ACCOUNTS_REQUEST_ERROR';
export function dupAmsAccountsRequestError() {
  return {
    type: DUP_AMS_ACCOUNTS_REQUEST_ERROR,
  };
}

/**
 * LaunchDarkly Service fetched Actions
 */
export const LAUNCH_DARKLY_FETCHED = 'LAUNCH_DARKLY_FETCHED';
export function launchDarklyFetched(feature) {
  return {
    type: LAUNCH_DARKLY_FETCHED,
    launchDarkly: feature,
  };
}
export const LAUNCH_DARKLY_REQUEST_STARTED = 'LAUNCH_DARKLY_REQUEST_STARTED';
export function launchDarklyRequestStarted() {
  return {
    type: LAUNCH_DARKLY_REQUEST_STARTED,
    isFetching: true,
    launchDarkly: null,
  };
}
export const LAUNCH_DARKLY_REQUEST_ERROR = 'LAUNCH_DARKLY_REQUEST_ERROR';
export function launchDarklyRequestError() {
  return {
    type: LAUNCH_DARKLY_REQUEST_ERROR,
  };
}
